import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import Snackbar from 'material-ui/Snackbar';
import Chip from 'material-ui/Chip';
import Moment from 'react-moment';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableFooter from '@material-ui/core/TableFooter';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Checkbox from '@material-ui/core/Checkbox';

import { API_ROOT } from './api/apiConfig';
import Loading from './components/Loading';
import Cookies from 'js-cookie';

const styles = {
  header: {
    padding: '16px',
    backgroundColor: '#0f172a',
    borderBottom: '1px solid #1e293b',
  },
  title: {
    fontSize: '20px',
    fontWeight: 500,
    color: '#e5e7eb',
  },
  subtitle: {
    fontSize: '13px',
    color: '#94a3b8',
    marginTop: '4px',
  },
  chip: { margin: 4 },
  wrapper: { display: 'flex', flexWrap: 'wrap' },
  countBadge: {
    display: 'inline-block',
    background: '#f43f5e',
    color: '#fff',
    borderRadius: '12px',
    padding: '2px 8px',
    fontSize: '12px',
    marginLeft: '8px',
    verticalAlign: 'middle',
  }
};

class NodeCCMigration extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dids: [],
      total: 0,
      multiSelect: [],
      alertOpen: false,
      notificationOpen: false,
      notificationText: '',
      loading: true,
      migrating: false,
      sortBy: 'has_paid_before',
      sortDir: 'desc',
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData() {
    const csrftoken = Cookies.get('csrftoken');
    this.setState({ loading: true });
    fetch(`${API_ROOT}/bridges/node-cc-migration/`, {
      credentials: 'include',
      headers: { 'X-CSRFToken': csrftoken }
    })
      .then(response => response.json())
      .then(data => {
        const sorted = this.sortDids(data.dids, this.state.sortBy, this.state.sortDir);
        this.setState({ dids: sorted, total: data.total, loading: false });
      })
      .catch(() => {
        this.setState({ loading: false, notificationOpen: true, notificationText: 'Error loading data' });
      });
  }

  handleClick(didId) {
    const index = this.state.multiSelect.indexOf(didId);
    const updated = [...this.state.multiSelect];
    if (index === -1) {
      updated.push(didId);
    } else {
      updated.splice(index, 1);
    }
    this.setState({ multiSelect: updated });
  }

  handleSelectAll() {
    if (this.state.multiSelect.length === this.state.dids.length) {
      this.setState({ multiSelect: [] });
    } else {
      this.setState({ multiSelect: this.state.dids.map(d => d.did_id) });
    }
  }

  isSelected = (didId) => this.state.multiSelect.indexOf(didId) !== -1;

  sortDids(dids, sortBy, sortDir) {
    return dids.slice().sort(function(a, b) {
      var av = a[sortBy], bv = b[sortBy];
      if (av === null || av === undefined) av = '';
      if (bv === null || bv === undefined) bv = '';
      if (typeof av === 'boolean') { av = av ? 1 : 0; bv = bv ? 1 : 0; }
      if (av < bv) return sortDir === 'asc' ? -1 : 1;
      if (av > bv) return sortDir === 'asc' ? 1 : -1;
      return 0;
    });
  }

  handleSort(col) {
    var newDir = (this.state.sortBy === col && this.state.sortDir === 'desc') ? 'asc' : 'desc';
    this.setState({
      sortBy: col,
      sortDir: newDir,
      dids: this.sortDids(this.state.dids, col, newDir),
    });
  }

  migrate(ids) {
    const csrftoken = Cookies.get('csrftoken');
    this.setState({ alertOpen: false, migrating: true });

    fetch(`${API_ROOT}/bridges/node-cc-migration/`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'X-CSRFToken': csrftoken,
      },
      body: JSON.stringify({ ids })
    })
      .then(response => response.json())
      .then(data => {
        const migratedCount = data.migrated ? data.migrated.length : 0;
        const errorCount = data.errors ? data.errors.length : 0;
        let msg = `Migrated ${migratedCount} number(s) to FS.`;
        if (errorCount > 0) {
          msg += ` ${errorCount} error(s) — check logs.`;
        }
        this.setState({
          migrating: false,
          multiSelect: [],
          notificationOpen: true,
          notificationText: msg,
        });
        this.fetchData();
      })
      .catch(() => {
        this.setState({
          migrating: false,
          notificationOpen: true,
          notificationText: 'Server error during migration. Check logs.',
        });
      });
  }

  render() {
    const { dids, total, loading, migrating, alertOpen, notificationOpen,
      notificationText, multiSelect } = this.state;

    if (loading) return <Loading />;

    const allSelected = dids.length > 0 && multiSelect.length === dids.length;

    const dialogActions = [
      <FlatButton label="Cancel" primary={true} onClick={() => this.setState({ alertOpen: false })} />,
      <FlatButton label="Migrate to FS" primary={true} keyboardFocused={true}
        onClick={() => this.migrate(multiSelect)} />,
    ];

    return (
      <div>
        <Snackbar
          open={notificationOpen}
          message={notificationText}
          autoHideDuration={5000}
          onRequestClose={() => this.setState({ notificationOpen: false })}
        />
        <Dialog
          title={`Migrate ${multiSelect.length} number(s) to FreeSWITCH?`}
          actions={dialogActions}
          modal={false}
          open={alertOpen}
          onRequestClose={() => this.setState({ alertOpen: false })}
        >
          This will update each number's Telnyx connection from node-cc to the FS connection,
          and update the service_provider in the database. This cannot be undone automatically.
        </Dialog>

        <div style={styles.header}>
          <div style={styles.title}>
            node-cc Migration
            <span style={styles.countBadge}>{total}</span>
          </div>
          <div style={styles.subtitle}>
            Numbers currently routed through node-cc. Select numbers and migrate them to FreeSWITCH.
          </div>
          {multiSelect.length > 0 &&
            <div style={{ marginTop: '10px' }}>
              <RaisedButton
                label={migrating ? 'Migrating...' : `Migrate ${multiSelect.length} selected to FS`}
                backgroundColor="#22c55e"
                labelColor="#fff"
                disabled={migrating}
                onClick={() => this.setState({ alertOpen: true })}
              />
            </div>
          }
        </div>

        {dids.length === 0
          ? <div style={{ padding: '32px', textAlign: 'center', color: '#64748b' }}>
              No numbers on node-cc. All clear!
            </div>
          : <Table>
              <TableHead style={{ backgroundColor: '#1e293b' }}>
                <TableRow>
                  <TableCell padding="checkbox">
                    <Checkbox checked={allSelected} onClick={() => this.handleSelectAll()} />
                  </TableCell>
                  <TableCell>Number</TableCell>
                  <TableCell>
                    <TableSortLabel active={this.state.sortBy === 'company_name'}
                      direction={this.state.sortBy === 'company_name' ? this.state.sortDir : 'asc'}
                      onClick={() => this.handleSort('company_name')}>Company</TableSortLabel>
                  </TableCell>
                  <TableCell>Owner Email</TableCell>
                  <TableCell>
                    <TableSortLabel active={this.state.sortBy === 'has_paid_before'}
                      direction={this.state.sortBy === 'has_paid_before' ? this.state.sortDir : 'desc'}
                      onClick={() => this.handleSort('has_paid_before')}>Paid?</TableSortLabel>
                  </TableCell>
                  <TableCell>
                    <TableSortLabel active={this.state.sortBy === 'tariff'}
                      direction={this.state.sortBy === 'tariff' ? this.state.sortDir : 'asc'}
                      onClick={() => this.handleSort('tariff')}>Plan</TableSortLabel>
                  </TableCell>
                  <TableCell>
                    <TableSortLabel active={this.state.sortBy === 'last_call'}
                      direction={this.state.sortBy === 'last_call' ? this.state.sortDir : 'desc'}
                      onClick={() => this.handleSort('last_call')}>Last Call</TableSortLabel>
                  </TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableHead>
              <TableBody style={{ backgroundColor: '#0f172a' }}>
                {dids.map((did, i) => {
                  const selected = this.isSelected(did.did_id);
                  return (
                    <TableRow
                      key={i}
                      role="checkbox"
                      aria-checked={selected}
                      selected={selected}
                      onClick={() => this.handleClick(did.did_id)}
                      style={{ cursor: 'pointer' }}
                    >
                      <TableCell padding="checkbox">
                        <Checkbox checked={selected} />
                      </TableCell>
                      <TableCell>{did.number}</TableCell>
                      <TableCell>
                        {did.company_id
                          ? <a
                              style={{ cursor: 'pointer', color: '#3b82f6' }}
                              onClick={(e) => {
                                e.stopPropagation();
                                this.props.history.push(`/company-detail/${did.company_id}`);
                              }}
                            >
                              {did.company_name || '—'}
                            </a>
                          : did.company_name || '—'
                        }
                      </TableCell>
                      <TableCell>{did.owner_email || '—'}</TableCell>
                      <TableCell>
                        {did.has_paid_before
                          ? <Chip labelStyle={{ fontSize: '10px' }} style={styles.chip} labelColor="#22c55e">Paid</Chip>
                          : <Chip labelStyle={{ fontSize: '10px' }} style={styles.chip} labelColor="#06b6d4">Never paid</Chip>
                        }
                      </TableCell>
                      <TableCell style={{ fontSize: '11px' }}>{did.tariff || '—'}</TableCell>
                      <TableCell>
                        {did.last_call
                          ? <Moment format="YYYY/MM/DD">{did.last_call}</Moment>
                          : '—'
                        }
                      </TableCell>
                      <TableCell>
                        <RaisedButton
                          labelStyle={{ fontSize: '10px' }}
                          label="Migrate to FS"
                          disabled={migrating}
                          onClick={(e) => {
                            e.stopPropagation();
                            this.migrate([did.did_id]);
                          }}
                        />
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
        }
      </div>
    );
  }
}

export default withRouter(NodeCCMigration);



// WEBPACK FOOTER //
// ./src/NodeCCMigration.js